import {
  AllessehContentType,
  GetScheduledContentByTimeWithAllessehIdQuery,
  MobileIssueDto,
  MobileIssueDtoArtifactFragment
} from 'data/generated/graphql';
import { isWithinTimeInterval } from 'utils/time';

export type ScheduledFromQuery =
  GetScheduledContentByTimeWithAllessehIdQuery['scheduledContentByTimeWithAllessehId'][number];

export function toScheduledIssueDto(opts: {
  issue: MobileIssueDtoArtifactFragment;
  publishUtc: number;
  // if your scheduler expects "wsj" style instead of "jwsj", pass it here
  publicationKeyOverride?: string;
}): {
  allessehId: string;
  contentType: AllessehContentType;
  publishUtc: number;
  body: MobileIssueDtoArtifactFragment;
} {
  const { issue, publishUtc } = opts;

  return {
    allessehId: issue.metadata.allessehId,
    contentType: AllessehContentType.MobileIssue,
    publishUtc,
    body: issue
  };
}

export function deriveScheduledState(items?: ScheduledFromQuery[]) {
  if (!items) return { scheduledIssues: null, soonPublishUtc: null };
  if (items.length === 0) return { scheduledIssues: null, soonPublishUtc: null };

  const scheduledIssues = items.map((scheduled) => {
    const body = scheduled.body as unknown as MobileIssueDto;
    return {
      ...scheduled,
      publishUtc: body.metadata.publishUtc ?? scheduled.publishUtc
    };
  });

  return {
    scheduledIssues,
    soonPublishUtc: items[0].publishUtc
  };
}

export function shouldSetSoonPublishUtc(currentSoon: number | null, nextPublishUtc: number, now: number) {
  if (currentSoon) return false;
  return isWithinTimeInterval(nextPublishUtc, now, 'hour');
}

export function shouldClearSoonPublishUtc(currentSoon: number | null, deletePublishUtc: number) {
  return isWithinTimeInterval(currentSoon ?? 0, deletePublishUtc, 'second');
}
